// 261015 P5a (D5) — dòng "Đã tự áp…" / "Chưa tự áp: …" trên thẻ khối ② ④ ⑤. Chữ do `autoApplyView.ts` dựng; file này chỉ vẽ.
import React from 'react';
import { Tag } from 'antd';
import type { AutoApplyNote } from './autoApplyView';

const AutoApplyLine: React.FC<{ note: AutoApplyNote | null }> = ({ note }) => {
  if (!note) return null;
  return (
    <div data-testid={`auto-apply-${note.kind}`} style={{ margin: '4px 0', fontSize: 13, wordBreak: 'break-word' }}>
      <Tag color={note.kind === 'applied' ? 'green' : 'gold'} style={{ marginRight: 6 }}>{note.kind === 'applied' ? 'tự áp' : 'chưa tự áp'}</Tag>
      <span>{note.text}</span>
    </div>
  );
};

export default AutoApplyLine;
